<form *ngIf="searchForm" [formGroup]="searchForm">
	<div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px">
		<div fxFlex="30" fxFlex.lt-md="100">
			<text-input-ctrl [caption]="'global.search'" formControlName="text"
				[settings]="{fxFill:true}"></text-input-ctrl>
		</div>

		<button type="button" kendoButton icon="search" (click)="searchAndResetPagesClick()"></button>
		<button type="button" kendoButton icon="plus" (click)="addNewLink()">
			{{ 'documents.sharedClaimLinks.addNew' | translate }}
		</button>
	</div>
</form>


<kendo-grid [data]="view | async"
	[loading]="loading"
	[pageSize]="rowsPerPage$ | async"
	[skip]="skip$ | async"
	[pageable]="true"
	scrollable="none"
	serverPaging="true"
	(dataStateChange)="dataStateChange($event)"
	(pageChange)="pageChange($event)"
	[size]="'small'">
	<kendo-grid-column field="actions" title="" [width]="50">
		<ng-template kendoGridCellTemplate let-link="dataItem">
			<button kendoButton type="button" icon="info"
				(click)="$event.stopPropagation(); showLink(link.id)">
			</button>
		</ng-template>
	</kendo-grid-column>

	<kendo-grid-column field="linkHash" title="{{ 'documents.sharedClaimLinks.linkHash' | translate }}">
		<ng-template kendoGridCellTemplate let-link="dataItem">
			<span>{{ link.linkHash }}</span>
		</ng-template>
	</kendo-grid-column>

	<kendo-grid-column field="tag" title="{{ 'documents.sharedClaimLinks.tag' | translate }}">
		<ng-template kendoGridCellTemplate let-link="dataItem">
			<strong>{{ link.tag }}</strong>
		</ng-template>
	</kendo-grid-column>

	<kendo-grid-column field="expirationDate" title="{{ 'documents.sharedClaimLinks.expirationDate' | translate }}">
		<ng-template kendoGridCellTemplate let-link="dataItem">
			<strong [class.expired]="isExpired(link.expirationDate)">
				{{ link.expirationDate | date:'yyyy-MM-dd HH:mm' }}
			</strong>
		</ng-template>
	</kendo-grid-column>

	<kendo-grid-column field="createdBy" title="{{ 'documents.sharedClaimLinks.createdBy' | translate }}"></kendo-grid-column>

	<kendo-grid-column field="timestamp" title="{{ 'documents.sharedClaimLinks.timestamp' | translate }}">
		<ng-template kendoGridCellTemplate let-link="dataItem">
			{{ link.timestamp | date:'yyyy-MM-dd HH:mm' }}
		</ng-template>
	</kendo-grid-column>

	<kendo-grid-column field="pinCode" title="{{ 'documents.sharedClaimLinks.pinCode' | translate }}"></kendo-grid-column>
</kendo-grid>

<div kendoDialogContainer #sharedClaimDocumentLinkDialog></div>
